export default function authHeader() {
    const user = JSON.parse(localStorage.getItem('user'));
  
    if (user && user.data.api_token) {
      return { Authorization: 'Bearer ' + user.data.api_token };
    } else {
      return {};
    }
}